var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
import { ListItem } from "@react-md/list";
var MenuItem = forwardRef(function MenuItem(_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.role, role = _b === void 0 ? "menuitem" : _b, _c = _a.tabIndex, tabIndex = _c === void 0 ? -1 : _c, props = __rest(_a, ["className", "children", "role", "tabIndex"]);
    return (React.createElement(ListItem, __assign({}, props, { ref: ref, role: role, tabIndex: tabIndex, className: cn("rmd-menu-item", className) }), children));
});
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        MenuItem.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            role: PropTypes.string,
            tabIndex: PropTypes.number,
            children: PropTypes.node,
        };
    }
    catch (e) { }
}
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map